"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const DropIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0943 1.99948L11.3054 2.93553L10.894 3.42455C10.6309 3.73781 10.2523 4.18895 9.79056 4.74078C8.86731 5.84419 7.61111 7.35062 6.27959 8.96245C5.46563 9.94435 4.87492 10.7666 4.50331 11.6496C4.12176 12.5561 4 13.4553 4 14.55C4 18.9776 7.57308 22.58 12 22.58C16.4269 22.58 20 18.9776 20 14.55C20 12.3003 19.1904 10.7107 17.7184 8.94006C16.4028 7.36029 15.1863 5.86459 14.2985 4.76355C13.8546 4.21316 13.4932 3.76167 13.2429 3.44797C13.1177 3.29113 13.0203 3.16875 12.9543 3.08569L12.8541 2.95937L12.0943 1.99948ZM11.3244 6.02423C11.5977 5.69767 11.8417 5.40647 12.0498 5.1584C12.2484 5.4062 12.4808 5.69565 12.7415 6.01896C13.6337 7.12534 14.8573 8.62984 16.1816 10.22C17.4692 11.7689 18 12.9199 18 14.55C18 17.8824 15.3131 20.58 12 20.58C8.68692 20.58 6 17.8824 6 14.55C6 13.6147 6.10324 13.0039 6.34669 12.4254C6.59999 11.8236 7.0341 11.186 7.81985 10.2382L7.82096 10.2369C9.14924 8.62898 10.4028 7.12567 11.3244 6.02423ZM11.24 19.09C14.1542 19.09 16.52 16.7242 16.52 13.81H15.02C15.02 15.8958 13.3258 17.59 11.24 17.59V19.09Z",
  fill: "currentColor"
}));

var _default = DropIcon;
exports.default = _default;